import React from "react"
import { Menu } from "@quorumus/plum"
import {
    MenuButton,
    ButtonsWrapper,
    DownloadButton,
    menuStyles,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/AddToCalendar/AddToCalendar.styles"
import { YahooIcon } from "QuorumGrassroots/widgets/ReusableComponents/YahooIcon/YahooIcon"
import { generateCalendarUrl, openCalendarUrl, CalendarType } from "./AddToCalendar.helper"

export interface CalendarEvent {
    title: string
    description?: string
    location?: string
    timezone?: string
    start: string
    end?: string
}

export interface AddToCalendarProps {
    event: CalendarEvent
    onDownloadICS?: () => void
}

export const AddToCalendar: React.FC<AddToCalendarProps> = ({ event, onDownloadICS }) => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false)

    const handleCalendarClick = (type: CalendarType) => {
        const url = generateCalendarUrl(event, type)
        openCalendarUrl(url)
    }

    const handleDownloadICS = () => {
        const url = generateCalendarUrl(event, "ics")
        openCalendarUrl(url)
        if (onDownloadICS) {
            onDownloadICS()
        }
    }

    return (
        <ButtonsWrapper>
            <Menu
                styles={menuStyles}
                closeOnItemClick
                onOpen={() => setIsMenuOpen(true)}
                onClose={() => setIsMenuOpen(false)}
            >
                <Menu.Target>
                    <MenuButton
                        size="lg"
                        leftSection={<i className="fa fa-calendar-o" aria-hidden="true" />}
                        rightSection={<i className={`fa fa-angle-${isMenuOpen ? "up" : "down"}`} aria-hidden="true" />}
                        data-cy="btn-add-to-calendar"
                    >
                        Add to calendar
                    </MenuButton>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        leftSection={<i className="fa fa-google" aria-hidden="true" />}
                        onClick={() => handleCalendarClick("google")}
                        data-cy="calendar-google"
                    >
                        Google
                    </Menu.Item>
                    <Menu.Item
                        leftSection={<i className="fa fa-windows" aria-hidden="true" />}
                        onClick={() => handleCalendarClick("office365")}
                        data-cy="calendar-office365"
                    >
                        Office365
                    </Menu.Item>
                    <Menu.Item
                        leftSection={<YahooIcon />}
                        onClick={() => handleCalendarClick("yahoo")}
                        data-cy="calendar-yahoo"
                    >
                        Yahoo
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
            <DownloadButton
                variant="secondary"
                size="lg"
                leftSection={<i className="fa fa-download" aria-hidden="true" />}
                onClick={handleDownloadICS}
                data-cy="btn-download-ics"
            >
                Download (.ICS)
            </DownloadButton>
        </ButtonsWrapper>
    )
}
